import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetDataToken } from "../../../hooks/useGetData";
import notify from "../../../Components/Utilities/notify";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";



//get all users
export const getAllCategories = createAsyncThunk(
    "/usersSlice/getAllCategories",
    async ({branchId}) => {
        try {
            const response = await useGetDataToken(`/api/v1/categories?branchId=${branchId}`);
            return response;
        } catch (error) {
            if (error.message == "Network Error")
                return notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
            else
            return notify(error.response.data,"error");
        }
    }
);


